
export default {
  name: 'ShapeBgCard',
  props: {
    blockOptions: {
      type: Object
    }
  }
}
